




















import { Component, Vue } from 'vue-property-decorator';
import md5 from 'blueimp-md5';
import storage from '../utils/storage';
import Loading from '../components/Loading.vue';
interface ArgsInter {
  userName: string;
  passWord: string;
}
@Component({
  components: {
    Loading,
  },
})
export default class Login extends Vue {
  private spinning: boolean = false;
  private userName: string = '';
  private passWord: string = '';
  private login(): void {
    const that = this;
    this.spinning = true;
    const url = '/api/login';
    const args: ArgsInter = {
      userName: this.userName,
      passWord: md5(this.passWord),
    };
    this.axios.post(url, args).then((res: any) => {
      if (res.data.code === 12) {
        storage.set('user', res.data);
        that.spinning = false;
        this.$router.push({
          path: '/Tracking',
        });
      } else {
        this.$message.error(res.data.msg);
        that.spinning = false;
      }
    }).catch((err) => {
      that.spinning = false;
      console.log(err);
    });

  }
  private emitEmptyUserName(): void {
    const inputBox: HTMLInputElement = this.$refs.userNameInput as HTMLInputElement;
    inputBox.focus();
    this.userName = '';
  }
  private emitEmptypassWord(): void {
    const inputBox: HTMLInputElement = this.$refs.passWordInput as HTMLInputElement;
    inputBox.focus();
    this.passWord = '';
  }

}
